// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"w4-z","colorTextValue":"x4-z","swatches":"y4-z","collapseLink":"z4-z","isCollapsed":"A4-z","dropdown":"B4-z","disabled":"C4-z"};